<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 32 32"
>
  <circle
    [attr.stroke]="color"
    cx="16"
    cy="16"
    r="15"
    stroke-width="2"
  />
  <path
    [attr.stroke]="color"
    d="M8 17L11.5858 20.5858C12.3668 21.3668 13.6332 21.3668 14.4142 20.5858L23 12"
    stroke-width="2"
  />
</svg>
